import { InjectionToken } from '@angular/core';
import * as Rx from 'rxjs';

export const WEBSOCKET_TEST_SCHEDULER = new InjectionToken<Rx.SchedulerLike>(
  'WebsocketTestScheduler',
);

export const RECONNECT_CONFIG = new InjectionToken<Rx.SchedulerLike>(
  'Reconnect Configuration',
);

export const RANDOM_NUMBER_PROVIDER = new InjectionToken<Rx.SchedulerLike>(
  'Random Number Provider',
);
